module.exports = ".socialLists span {\n  margin: 10px 0;\n  font-size: 20px; }\n\n.otherLists span {\n  margin: 10px 0;\n  font-size: 20px; }\n"